<app-new-version
  *ngIf="appUpdateAvailable$ | async"
  (click)="loadNewVersion()"
/>
<router-outlet></router-outlet>
